<template>
  <div>
    <e-commerce-left-menu/>

    <router-view></router-view>
  </div>
</template>
<script>
  import ECommerceLeftMenu from './EcommerceLeftMenu';
  export default {
    name: 'ecommerce-layout',
    components: {
      ECommerceLeftMenu
    }
  }
</script>
<style>
</style>
